// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общие стили */
.CaesarСipher-subtitle {
  display: grid;
  font-size: 2vw;
  place-self: center;
}
.CaesarСipher-buttonCheck {
  display: flex;
  gap: 0.5vw;
  padding: 0.4vw 0.75vw;
  justify-content: space-evenly;
  border-radius: 0.9vw;
  width: max-content;
  cursor: pointer;
  color: white;
  place-self: center;
  font-size: 1.8vw;
  white-space: nowrap;
  background-color: #1a6a7c;
}
.CaesarСipher-logoRun {
  height: 2.1vw;
  place-self: center;
}

.CaesarСipher-Board {
  display: flex;
  gap: 4vw;
}
/* ---------------алфавит с цифрами---------------*/
.CaesarСipher-alphabet-wrapper {
  align-self: center;
  display: flex;
  flex-direction: row;
  gap: 0.5vw;

  align-items: start;
}
#CaesarСipher-alphabet-icon {
  height: auto;
}
.CaesarСipher-icon--disabled {
  filter: brightness(80%);
  cursor: not-allowed;
  pointer-events: none;
}
#CaesarСipher-alphabet-icon:active {
  filter: brightness(0.7);
}
.CaesarСipher-alphabet {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border: 0.1vw #1a6a7c solid;
}
.CaesarСipher-rows {
  display: flex;
  flex-direction: row;
}
.CaesarСipher-rows:first-child {
  border-bottom: 0.1vw solid #1a6a7c;
}
.CaesarСipher-alphabet-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2.5vw;
  height: 2.5vw;
  font-size: 2vw;
  font-weight: bold;
  border-right: 0.1vw solid #1a6a7c;
}
.CaesarСipher-alphabet-item:last-child {
  border-right: none;
}
/* -----------------игровое поле ------------*/
.CaesarСipher-game-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2vw;
}
.CaesarСipher-board-wrapper {
  display: grid;
  padding: 0 4vw;
  gap: 2vw;
  grid-template-columns: 76% auto;
}
.CaesarСipher-board-content {
  display: flex;
  margin-top: 3.2vw;
  gap: 4vw;
}
.CaesarСipher-board {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1;
  gap: 1vw;
}
/* ключ с цифрой */
.CaesarСipher-key-cipher-content{
  min-height: 7vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap:4vw;
}
.CaesarСipher-key-content {
  display: flex;
  height: 4vw;
  border: 0.1vw solid #1a6a7c;
  background-color: #ffffff;
}
.CaesarСipher-key-img {
  padding: 0.4vw;
  width: 4vw;
  border-right: 0.1vw solid #1a6a7c;
}
.CaesarСipher-key-number {
  display: flex;
  font-size: 3vw;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  width: 4vw;
}
/* поле с шифром */
.CaesarСipher-cipher {
  margin-top: auto;
  display: flex;
  background-color: #ffffff;
  border: 0.1vw solid #1a6a7c;
  font-size: 3vw;
  font-weight: bold;
  padding: 0.2vw 2vw;
  gap: 1.5vw;
}
.CaesarСipher-cipher--small {
  font-size: 2.5vw;
  gap: 1vw;
}
/* поле с кнопкой и полем для проверки отгадки */

.CaesarСipher-button-input-board {
  -webkit-user-select: none;
          user-select: none;
  display: grid;
  gap: 0.4vw;
  grid-template-columns: auto auto 8vw;
}

.CaesarСipher-input {
  padding-left: 0.8vw;
  font-size: 2vw;
  height: 3vw;
  background-color: #ffffff;
  outline: none;
  text-transform: uppercase;
  border: 0.1vw #1a6a7c solid;
  border-radius: 0.6vw;
}
.CaesarСipher-wrong {
  background: #ffc0c0;
}

.CaesarСipher-correct {
  background: #e6ffe6;
}
/* ПОБЕДА */
.CaesarСipher-card-container {
  display: grid;
  margin-top: auto;
  margin-bottom: auto;
  perspective: 1000px;
}

.CaesarСipher-card-flipped {
  transform: rotateY(180deg);
}

.CaesarСipher-card {
  position: relative;
  display: grid;
  transform-style: preserve-3d;
  transition: transform 2s ease;
}

.CaesarСipher-card-face {
  grid-area: 1 / 1;

  display: flex;
  justify-content: center;
  align-items: center;

  backface-visibility: hidden;
}

.CaesarСipher-card-front {
  background: white;
}

.CaesarСipher-card-back {
  position: absolute;
  inset: 0;

  background: white;
  transform: rotateY(180deg);
}
.CaesarСipher-win-square {
  display: flex;
  justify-content: center;
  align-items: center;

  background: white;
}

.CaesarСipher-win-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/CaesarСipher/styles/Caesar%D0%A1ipherBoard.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,UAAU;EACV,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;;EAEV,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;AACA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;EACR,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,QAAQ;AACV;AACA,kBAAkB;AAClB;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,OAAO;AACT;AACA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;AACA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,QAAQ;AACV;AACA,gDAAgD;;AAEhD;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA,WAAW;AACX;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;;EAEhB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;;EAER,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Общие стили */\n.CaesarСipher-subtitle {\n  display: grid;\n  font-size: 2vw;\n  place-self: center;\n}\n.CaesarСipher-buttonCheck {\n  display: flex;\n  gap: 0.5vw;\n  padding: 0.4vw 0.75vw;\n  justify-content: space-evenly;\n  border-radius: 0.9vw;\n  width: max-content;\n  cursor: pointer;\n  color: white;\n  place-self: center;\n  font-size: 1.8vw;\n  white-space: nowrap;\n  background-color: #1a6a7c;\n}\n.CaesarСipher-logoRun {\n  height: 2.1vw;\n  place-self: center;\n}\n\n.CaesarСipher-Board {\n  display: flex;\n  gap: 4vw;\n}\n/* ---------------алфавит с цифрами---------------*/\n.CaesarСipher-alphabet-wrapper {\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n  gap: 0.5vw;\n\n  align-items: start;\n}\n#CaesarСipher-alphabet-icon {\n  height: auto;\n}\n.CaesarСipher-icon--disabled {\n  filter: brightness(80%);\n  cursor: not-allowed;\n  pointer-events: none;\n}\n#CaesarСipher-alphabet-icon:active {\n  filter: brightness(0.7);\n}\n.CaesarСipher-alphabet {\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  border: 0.1vw #1a6a7c solid;\n}\n.CaesarСipher-rows {\n  display: flex;\n  flex-direction: row;\n}\n.CaesarСipher-rows:first-child {\n  border-bottom: 0.1vw solid #1a6a7c;\n}\n.CaesarСipher-alphabet-item {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 2.5vw;\n  height: 2.5vw;\n  font-size: 2vw;\n  font-weight: bold;\n  border-right: 0.1vw solid #1a6a7c;\n}\n.CaesarСipher-alphabet-item:last-child {\n  border-right: none;\n}\n/* -----------------игровое поле ------------*/\n.CaesarСipher-game-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 2vw;\n}\n.CaesarСipher-board-wrapper {\n  display: grid;\n  padding: 0 4vw;\n  gap: 2vw;\n  grid-template-columns: 76% auto;\n}\n.CaesarСipher-board-content {\n  display: flex;\n  margin-top: 3.2vw;\n  gap: 4vw;\n}\n.CaesarСipher-board {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: space-between;\n  flex: 1 1;\n  gap: 1vw;\n}\n/* ключ с цифрой */\n.CaesarСipher-key-cipher-content{\n  min-height: 7vw;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap:4vw;\n}\n.CaesarСipher-key-content {\n  display: flex;\n  height: 4vw;\n  border: 0.1vw solid #1a6a7c;\n  background-color: #ffffff;\n}\n.CaesarСipher-key-img {\n  padding: 0.4vw;\n  width: 4vw;\n  border-right: 0.1vw solid #1a6a7c;\n}\n.CaesarСipher-key-number {\n  display: flex;\n  font-size: 3vw;\n  font-weight: bold;\n  justify-content: center;\n  align-items: center;\n  width: 4vw;\n}\n/* поле с шифром */\n.CaesarСipher-cipher {\n  margin-top: auto;\n  display: flex;\n  background-color: #ffffff;\n  border: 0.1vw solid #1a6a7c;\n  font-size: 3vw;\n  font-weight: bold;\n  padding: 0.2vw 2vw;\n  gap: 1.5vw;\n}\n.CaesarСipher-cipher--small {\n  font-size: 2.5vw;\n  gap: 1vw;\n}\n/* поле с кнопкой и полем для проверки отгадки */\n\n.CaesarСipher-button-input-board {\n  user-select: none;\n  display: grid;\n  gap: 0.4vw;\n  grid-template-columns: auto auto 8vw;\n}\n\n.CaesarСipher-input {\n  padding-left: 0.8vw;\n  font-size: 2vw;\n  height: 3vw;\n  background-color: #ffffff;\n  outline: none;\n  text-transform: uppercase;\n  border: 0.1vw #1a6a7c solid;\n  border-radius: 0.6vw;\n}\n.CaesarСipher-wrong {\n  background: #ffc0c0;\n}\n\n.CaesarСipher-correct {\n  background: #e6ffe6;\n}\n/* ПОБЕДА */\n.CaesarСipher-card-container {\n  display: grid;\n  margin-top: auto;\n  margin-bottom: auto;\n  perspective: 1000px;\n}\n\n.CaesarСipher-card-flipped {\n  transform: rotateY(180deg);\n}\n\n.CaesarСipher-card {\n  position: relative;\n  display: grid;\n  transform-style: preserve-3d;\n  transition: transform 2s ease;\n}\n\n.CaesarСipher-card-face {\n  grid-area: 1 / 1;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  backface-visibility: hidden;\n}\n\n.CaesarСipher-card-front {\n  background: white;\n}\n\n.CaesarСipher-card-back {\n  position: absolute;\n  inset: 0;\n\n  background: white;\n  transform: rotateY(180deg);\n}\n.CaesarСipher-win-square {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background: white;\n}\n\n.CaesarСipher-win-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
